/*
 * Public API Surface of customers-service
 */

export * from './lib/api/models';
export * from './lib/api/services';
export * from './lib/api/api.module';
